import React from 'react';

/**
 * Rushes icon (24px) + "RUSHES MEET" lockup. Renders as a link when `href` is
 * given, otherwise as an inert span (use that on the landing page itself).
 */
export function Brand({ href, className }: { href?: string; className?: string }) {
  const cls = className ? `m-brand ${className}` : 'm-brand';
  const inner = (
    <>
      {/* eslint-disable-next-line @next/next/no-img-element -- 24px static icon */}
      <img src="/icon-192.png" alt="" width={24} height={24} />
      <span className="m-label">Rushes Meet</span>
    </>
  );
  if (href) {
    return (
      <a className={cls} href={href} aria-label="Rushes Meet">
        {inner}
      </a>
    );
  }
  return (
    <span className={cls} aria-label="Rushes Meet">
      {inner}
    </span>
  );
}
